export default "__VITE_PUBLIC_ASSET__530ab361__"